var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u21B3 Icon Color",
    d: "M11.83 -0.12C12.62 -0.12 12.91 -0.03 13.2 0.12C13.49 0.28 13.71 0.5 13.87 0.79C14.02 1.08 14.11 1.37 14.11 2.16L14.11 8.27C14.11 9.06 14.02 9.35 13.87 9.64C13.71 9.93 13.49 10.16 13.2 10.31C12.91 10.47 12.62 10.55 11.83 10.55L7.88 10.55L4.58 13.86C4.32 14.12 3.9 14.12 3.63 13.86C3.51 13.73 3.44 13.56 3.44 13.39L3.44 10.55L2.16 10.55C1.37 10.55 1.08 10.47 0.79 10.31C0.5 10.16 0.28 9.93 0.12 9.64C-0.03 9.35 -0.12 9.06 -0.12 8.27L-0.12 2.16C-0.12 1.37 -0.03 1.08 0.12 0.79C0.28 0.5 0.5 0.28 0.79 0.12C1.08 -0.03 1.37 -0.12 2.16 -0.12L11.83 -0.12Z",
    fill: "#7E7E7E",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.700bb0406f957913a5c3558b28d8b86b.svg";
export { ForwardRef as ReactComponent };